import { formatPrismicData } from '@monofront/business/utils';
import { EditorialListAndImageProps, IEditorialListAndImage } from './types';

export const mapEditorialListAndImage = ({
  prismicContent,
}: {
  prismicContent: EditorialListAndImageProps;
}): IEditorialListAndImage => {
  const { primary, items }: IEditorialListAndImage =
    formatPrismicData(prismicContent);

  return {
    primary,
    items,
  };
};
